<template>
  <div>
    <!--Message d'erreur mail-->
    <alert :success=false :display=mailError text="Adresse invalide" type="mailError"
           v-on:mailError="setDisplay('mailError')"/>

    <!--Messages d'erreur-->
    <alert :success=false :display=servError text="Le mail n'a pas pu être envoyé" type="servError"
           v-on:servError="setDisplay('servError')"/>

    <!--Message de succès-->
    <alert :success=true :display=success :text="'Email envoyé à l\'adresse ' + mail"
           type="success"
           v-on:success="setDisplay('success')"/>

    <p>
      Merci d'indiquer l'adresse email renseignée lors de la commande pour recevoir la procédure de
      {{type==='recovery' ? "récupération de mot de passe" : "création de compte"}}.
    </p>

    <form @submit="formSubmit" class="ml-2 mt-3">
      <div class="form-group row mb-5">
        <label for="emailInput"
               class="col-sm-4 col-form-label text-left text-sm-right ml-sm-0 mb-sm-1 mx-3 mb-1">
          Adresse mail</label>
        <div class="col-sm-7">
          <input
            id="emailInput"
            type="email"
            class="form-control"
            v-model="mail"
            placeholder="monadresse@mail.com"
            :class="{ 'is-invalid': this.$v.mail.$error }"
            @input="$v.mail.$touch()">
          <div class="text-danger" v-if="!this.$v.mail.required && this.$v.mail.$error">
            Le champ est requis
          </div>
          <div class="text-danger" v-if="!this.$v.mail.email && this.$v.mail.$error">
            L'adresse mail est invalide
          </div>
        </div>
      </div>
      <button class="btn btn--color-danger float-left"
              data-dismiss="modal" aria-label="Close">
        RETOUR
      </button>
      <button class="btn btn-success btn--color-success float-right"
              :disabled="!this.$v.mail.required || !this.$v.mail.email"
              :class="{ 'disabled': !this.$v.mail.required || !this.$v.mail.email }">
        ENVOYER
      </button>
    </form>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import axios from 'axios';
import Alert from '../Alert.vue';

export default {
  name: 'EmailForm',
  components: { Alert },
  props: {
    // Change la destination du formulaire
    type: String,
  },
  data() {
    return {
      mail: '',
      mailError: 'none',
      servError: 'none',
      success: 'none',
    };
  },
  methods: {
    setDisplay(displayable) {
      if (displayable === 'mailError') this.mailError = 'none';
      if (displayable === 'servError') this.servError = 'none';
      if (displayable === 'success') this.success = 'none';
    },
    formSubmit(e) {
      e.preventDefault();
      axios.post('/auth/api/front/mail', JSON.stringify({
        mail: this.mail,
        type: this.type,
        source: this.$parent.$parent.source,
      }), { headers: { 'content-type': 'application/json' } })
        .then(() => {
          this.success = 'block';
        })
        .catch((error) => {
          if (error.response.status === 500) {
            this.servError = 'block';
          } else {
            this.mailError = 'block';
          }
        });
    },
  },
  // Règles de validation du formulaire
  validations: {
    mail: {
      required,
      email,
    },
  },
};
</script>
